<template>
    <div>
        <v-overlay :value="loadingUsersList">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card class="col-item" flat style="border-top: 1px solid lightgray">
            <v-data-table
                :headers="tableHeaders"
                dense
                :items="users"
                :items-per-page="100"
                :footer-props="footerProps"
            >
                <template v-slot:item="{ item }">
                    <tr
                        :key="'user_' + item.id"
                        @click="handleTableRowClick(item)"
                        :class="{ activeTableRow: activeUser && parseInt(item.id) === parseInt(activeUser.id) }"
                    >
                        <td>{{ item.id }}</td>
                        <td>{{ item.first_name }} {{ item.last_name }}</td>
                        <td style="text-align: end">{{ item.email }}</td>
                        <td style="text-align: end">
                            <span class="dot" :style="{ 'background-color': getStatusColor(item.user_status) }"></span>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>
        <v-navigation-drawer :value="drawerOpen" fixed right hide-overlay width="900">
            <user-view v-if="$route.name === 'user-view'"></user-view>
            <user-edit v-if="$route.name === 'user-edit'"></user-edit>
        </v-navigation-drawer>
    </div>
</template>
<script>
import Store from "@/store";
import { mapActions, mapState } from "vuex";
import UserView from "./user-view";
import UserEdit from "./user-edit";
import router from "@/router";
export default {
    name: "users-list",
    components: { UserView, UserEdit },
    data() {
        return {
            tableHeaders: [
                {
                    text: this.t("ID"),
                    align: "left",
                    value: "id"
                },
                {
                    text: this.t("Name"),
                    align: "left",
                    value: "amount"
                },

                {
                    text: this.t("Email"),
                    align: "end",
                    value: "reference_no"
                },
                {
                    text: this.t("Status"),
                    align: "end",
                    value: "status"
                }
            ],
            footerProps: { "items-per-page-options": [25, 50, 100, 500] },
            mainDrawerOpen: null
        };
    },
    computed: {
        ...mapState([
            "users",
            "drawerOpen",
            "requestError",
            "errorMessage",
            "requestSuccess",
            "user",
            "activeUser",
            "loadingUsersList"
        ])
    },
    mounted() {
        if (this.user.role === "admin" || this.user.company_role === "owner") {
            Store.dispatch("getUsers");
            document.addEventListener("keydown", this.handleKeyboardListener);
            const drawerState = localStorage.getItem("mainDrawerOpen");
            if (drawerState) {
                this.mainDrawerOpen = JSON.parse(drawerState);
            } else {
                this.mainDrawerOpen = true;
            }
        } else {
            router.push("/admin/landing");
        }
    },
    destroyed() {
        document.removeEventListener("keydown", this.handleKeyboardListener);
    },
    methods: {
        ...mapActions(["getUserData", "getCompanyData"]),
        async handleTableRowClick(user) {
            if (this.$route.name !== "user-view") {
                await this.$router.push({ name: "user-view", params: { userId: user.id } });
                return;
            }
            if (this.$route.name === "user-view" && parseInt(user.id) !== parseInt(this.$route.params.userId)) {
                await this.$router.push({ name: "user-view", params: { userId: user.id } });
                await this.getUserData(user.id);
                if (this.activeUser.company_id) {
                    await this.getCompanyData(this.activeUser.company_id);
                }
            }
        },
        getStatusColor(status) {
            if (status === "active") {
                return "#4CAF50";
            } else if (status === "deleted") {
                return "#FF0000";
            } else if (status === "pending") {
                return "#FFA200";
            } else {
                return "#999999";
            }
        },
        async handleKeyboardListener(e) {
            if (e.keyCode === 27 && this.drawerOpen) {
                await this.$router.push({ name: "users-list" });
            }
            if (
                this.activeUser &&
                Object.keys(this.activeUser).length > 0 &&
                this.activeUser.id !== "new" &&
                this.$route.name !== "user-edit"
            ) {
                let currentProductIndex = this.users.findIndex(p => p.id === this.activeUser.id);
                if (e.key === "ArrowUp") {
                    if (currentProductIndex !== 0) {
                        const newUserId = this.users[currentProductIndex - 1].id;
                        await Store.dispatch("getUserData", newUserId);
                        await Store.dispatch("getCompanyData", this.activeUser.company_id);
                        await this.$router.push({ name: this.$route.name, params: { userId: newUserId } });
                    }
                } else if (e.key === "ArrowDown") {
                    if (currentProductIndex + 1 !== this.users.length) {
                        const newUserId = this.users[currentProductIndex + 1].id;
                        await Store.dispatch("getUserData", newUserId);
                        await Store.dispatch("getCompanyData", this.activeUser.company_id);
                        await this.$router.push({ name: this.$route.name, params: { userId: newUserId } });
                    }
                }
            }
        }
    }
};
</script>
<style>
.activeTableRow {
    background-color: #707070;
    color: #fff;
}
.activeTableRow:hover {
    background-color: #8d8d8d !important;
    color: #fff !important;
}
.dot {
    margin-top: 4px;
    height: 15px;
    width: 15px;
    border-radius: 50%;
    display: inline-block;
}
</style>
